module.exports = __webpack_public_path__ + "static/assets/4c60e82c56018cf918df90ba430ab7b7.gif";